export const footerColumns = [
  {
    title: '快速导航',
    links: [
      { label: '首页', href: '/' },
      { label: '赛事直播', href: '/category/live' },
      { label: '数据分析', href: '/category/data' },
      { label: '足球互动', href: '/category/interactive' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '信誉保障', href: '/about#reputation' },
      { label: '联系我们', href: '/about#contact' },
      { label: '用户协议', href: '/about' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '常见问题', href: '/about' },
      { label: '新手指南', href: '/article/newbie-guide' },
      { label: '安全中心', href: '/about#reputation' },
      { label: '意见反馈', href: '/about#contact' },
    ],
  },
];